import { useQuery } from '@tanstack/react-query';
import apiClient from '../api/axios';

export function useUser() {
  return useQuery({
    queryKey: ['user'],
    queryFn: async () => {
      const { data } = await apiClient.get('/me');
      return data?.data?.user;
    },
    staleTime: 5 * 60 * 1000, // 5 minutes - allow some caching
    cacheTime: 10 * 60 * 1000, // 10 minutes cache time
    refetchOnWindowFocus: false,
    refetchOnMount: true,
    retry: 0, // don't retry on 401 errors
  });
}